import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const fadeInUpFunc = () => {
  const target = document.querySelector('.js-fadeInUp');
  if (target === null) return;
  const items = gsap.utils.toArray<HTMLElement>('.js-fadeInUp');
  items.forEach((item) => {
    gsap.fromTo(
      item,
      {
        y: 50,
        autoAlpha: 0,
      },
      {
        y: 0,
        autoAlpha: 1,
        duration: 0.795,
        ease: 'power1.inOut',
        scrollTrigger: {
          trigger: item,
          start: 'top 95%',
        },
      }
    );
  });
};

export { fadeInUpFunc };
